import { css, styled } from '@mui/material';

import { popoverArrowClasses } from './theme';

import type { PopoverArrowOwnerState, PopoverArrowProps } from './types';

const PopoverArrow = (props: PopoverArrowProps) => {
  const { placement = 'top', arrow = false } = props; // 기본값 설정

  if (!arrow) return null;

  const ownerState: PopoverArrowOwnerState = {
    ...props,
    placement,
    arrow,
  };

  return (
    <StyledPopoverArrow ownerState={ownerState}>
      <StyledPopoverArrowIcon ownerState={ownerState} />
    </StyledPopoverArrow>
  );
};

// Styled Components
const StyledPopoverArrow = styled('div', {
  target: popoverArrowClasses.root,
})<{ ownerState: PopoverArrowOwnerState }>(({ ownerState }) => {
  const { placement } = ownerState;

  // placement variants 스타일
  const placementStyles: Record<NonNullable<PopoverArrowOwnerState['placement']>, any> = {
    top: {
      bottom: -6,
      left: 'calc(50% - 7px)',
      filter: 'drop-shadow(0px 1px 1px #13161926)',
      ['& > div']: {
        bottom: 0,
        clipPath: 'polygon(50% 100%, 0% 50%, 100% 50%)',
      },
    },
    right: {
      top: 'calc(50% - 7px)',
      left: -6,
      filter: 'drop-shadow(-1px 0px 1px #13161926)',
      ['& > div']: {
        left: 0,
        clipPath: 'polygon(0% 50%, 50% 0%, 50% 100%)',
      },
    },
    bottom: {
      top: -6,
      left: 'calc(50% - 7px)',
      filter: 'drop-shadow(0px -1px 1px #13161926)',
      ['& > div']: {
        top: 0,
        clipPath: 'polygon(50% 0%, 100% 50%, 0% 50%)',
      },
    },
    left: {
      top: 'calc(50% - 7px)',
      right: -6,
      filter: 'drop-shadow(1px 0px 1px #13161926)',
      ['& > div']: {
        right: 0,
        clipPath: 'polygon(100% 50%, 50% 100%, 50% 0%)',
      },
    },
  };

  return css`
    position: absolute;
    ${placement && placementStyles[placement]}
  `;
});

const StyledPopoverArrowIcon = styled('div', {
  target: popoverArrowClasses.icon,
})<{ ownerState: PopoverArrowOwnerState }>`
  position: absolute;
  width: 14px;
  height: 14px;
  background: white;
`;

export default PopoverArrow;
